import { Application } from "@hotwired/stimulus";

export default Application.start();